import React, { ReactElement, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import FacebookButton from 'octa-front-sdk/dist/components/FacebookButton';
import { FacebookLoginInfo } from 'octa-front-sdk';
import RequestHandler from 'octa-front-sdk/dist/RequestHandler';
import Loader from '../Loader';
import OrganizationContext from '../../contexts/OrganizationContext';
import GlobalContext from '../../contexts/GlobalContext';

interface IProps {
  onLogin?: () => void;
}

const FacebookBtn: React.FC<IProps> = (props): ReactElement => {
  const history = useHistory();
  const { onLogin } = props;
  const { setLoggedIn, setTokenFacebook, setToastMessage } = useContext(
    GlobalContext,
  );
  const { organizationInfo } = useContext(OrganizationContext);
  const [isLoading, setIsLoading] = useState(false);

  function handleClick(userInfo: FacebookLoginInfo): void {
    setIsLoading(true);

    const token = userInfo.accessToken;

    RequestHandler.get(`auth/exists/facebook?token=${token}`)
      .then((response): void => {
        const userExists = response.data.exists;

        if (userExists) {
          RequestHandler.post('auth/login/facebook', { token }).then(
            (response): void => {
              const { data } = response;

              Object.keys(data).map((key): void =>
                localStorage.setItem(key, data[key]),
              );

              setLoggedIn(true);

              if (onLogin) onLogin();
            },
          );
        } else {
          setTokenFacebook(token);

          history.push(
            `/${
              organizationInfo && organizationInfo.urlSuffix
            }/perfil/cadastrar/facebook`,
          );
        }
      })
      .catch((err): void => {
        setToastMessage('Houve algum erro ao entrar com facebook');
      })
      .finally(() => setIsLoading(false));
  }

  return (
    <>
      {isLoading && <Loader />}
      <FacebookButton
        handleFBLogin={handleClick}
        text="Continuar com Facebook"
        scope={['public_profile', 'email']}
      />
    </>
  );
};

export default FacebookBtn;
